import styled from 'styled-components';

const CouponModalStyled = styled.div`
  max-width: 1280px;
  .coupon-name-wrap {
    width: 100%;
    height: 35px;
  }
  .coupon-list {
    width: 100%;
  }
  .modal-btn-wrap {
    display: flex;
    flex-direction: row;
    float: right;
    /* margin-bottom:35px; */
    gap: 6px;
    margin-top: ${(props) => props.theme.spacing(23 / 8)};
    margin-bottom: ${(props) => props.theme.spacing(35 / 8)};
  }
`;

export default CouponModalStyled;
